<template>
  <div id="main-nav" v-bind:class="{'side-nav-collapsed': sideNavCollapsed}">
    <user-info v-if='isPluginView' :user='user' :side-nav-collapsed="sideNavCollapsed" :is-plugin-view="isPluginView" :user-info-handlers="userInfoHandlers" />
    <div id="left-nav-menu" v-bind:class="{'side-nav-collapsed': sideNavCollapsed}">
      <div class='app-logo' v-bind:class="{'app-logo-collapsed': sideNavCollapsed}">
        <img class="app-logo-img" :src='sideNavLogo' />
        </div>
        <div class="side-nav-list-wrapper">
          <div class="flip-container" v-bind:class="{ 'flipped' : showAvail }">
            <div class="flipper">
              <div class="front">
                <ul class="side-nav-list">
                  <li class="category active" @click='pcFunc()'>
                    <div class="category-link">
                      <div class="icon-container">
                        <img class="icon-image" style="padding:3px;" src='static/assets/img/SVGIcons/icon-pando-customer-white.svg' />
                            </div>
                        <div class="category-name">
                          PandoProfile
                        </div>
                      </div>
                  </li>
                  <li class="subcategories">
                    <ul class="subcategory-list">
                      <li class='subcategory-item' @click='custSearchFunc()' v-if='!isPluginView' :class='{"active": selectedCategory =="search" }'>
                        Customer Search
                      </li>
                      <li class='subcategory-item' @click='recentFunc()' :class="{'active': (selectedCategory == 'recent' || selectedCategory == '') && !isPluginView}">
                        Recently Viewed
                      </li>
                      <li class='subcategory-item' @click='highFunc()' :class="{'active': selectedCategory == 'highIntensity' && !isPluginView}">
                        High Intensity Active Leads
                      </li>
                      <li class='subcategory-item' @click='lowFunc()' :class="{'active': selectedCategory == 'losingIntensity' && !isPluginView}">
                        Active Leads Losing Intensity
                      </li>
                      <li class='subcategory-item' @click='bimFunc()' :class="{'active': selectedCategory == 'soldBim' && !isPluginView}">
                        Sold Customers Back In Market
                      </li>
                      <li class='subcategory-item' @click='lostFunc()' :class="{'active': selectedCategory == 'lostLeads' && !isPluginView}">
                        Lost Leads in Market
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
              <div class="back p-3">
                <availability @cancel='showAvail = false' @submitavail='submitAvail($event)' :user='user'></availability>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import UserInfo from "../Users/UserInfo.vue";
import Availability from "../Availability/Availability.vue";
import { MessengerAPIClient } from "@/lib/data_access/messenger";

export default {
  name: "mainNav",
  components: {
    UserInfo,
    Availability
  },
  props: [
    "sideNavCollapsed",
    "user",
    "userInfoHandlers",
    "isPluginView",
    "recentFunc",
    "highFunc",
    "bimFunc",
    "lostFunc",
    "pcFunc",
    "toggleAvail",
    "availabilityHandlers",
    "hideUserInfo",
    "lowFunc",
    "custSearchFunc"
  ],
  computed: {
    sideNavLogo: function() {
      let vm = this;
      if (!vm.sideNavCollapsed) {
        return "static/assets/img/pando-profile-logo.svg";
      } else {
        return "https://assets.autoalert.com/img/autoalert-icons/icon-pando-profile-lake.svg";
      }
    }
  },
  data: function() {
    return {
      showAvail: false,
      selectedCategory: ""
    };
  },
  created: function() {
    let vm = this;
  },
  methods: {
    submitAvail(availabilityPayload) {
      let vm = this;
      MessengerAPIClient.setAvailability(availabilityPayload).then(function() {
        vm.showAvail = false;
      });
    }
  },
  watch: {
    toggleAvail: function(newVal, oldVal) {
      let vm = this;
      vm.showAvail = true;
      vm.$emit("availEvent", false);
    },
    "$route.query.report": function(newVal, oldVal) {
      let vm = this;
      if (newVal) {
        vm.selectedCategory = newVal;
      } else {
        vm.selectedCategory = "";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../styles/_navigationmenu.scss";

#main-nav {
  width: $Main-side-nav-width;
  height: 100%;
  padding: 0;
  background-color: $white;
  transition: $Transition-speed;

  #left-nav-menu {
    width: 100%;
    .footer-back {
      // background-color: $blue-lt;
      position: absolute;
      bottom: 0;
      width: 100%;
    }

    .side-nav-list-wrapper {
      height: calc(100vh - 120px);
      overflow-x: hidden;
    }

    &.is-plugin-view {
      .side-nav-list-wrapper {
        width: $Plugin-width;
      }
    }

    &.is-plugin-view {
      width: $Plugin-width;
    }

    .side-nav-list-wrapper {
      .flip-container {
        perspective: 1000;
      }

      /* flip the pane when hovered */
      .flip-container.flipped .flipper {
        transform: rotateY(180deg);
      }

      .flip-container,
      .front,
      .back {
        width: $Main-side-nav-width;
        // height: calc(100vh - 59px - 45px);
        height: auto;
      }

      /* flip speed goes here */
      .flipper {
        transition: 0.6s;
        transform-style: preserve-3d;
        position: relative;
      }

      /* hide back of pane during swap */
      .front,
      .back {
        backface-visibility: hidden;
        position: absolute;
        top: 0;
        left: 0;
        -webkit-backface-visibility: hidden;
        -moz-backface-visibility: hidden;
        -ms-backface-visibility: hidden;
        backface-visibility: hidden;
        -webkit-transition: 0.6s;
        -webkit-transform-style: preserve-3d;
        -moz-transition: 0.6s;
        -moz-transform-style: preserve-3d;
        -o-transition: 0.6s;
        -o-transform-style: preserve-3d;
        -ms-transition: 0.6s;
        -ms-transform-style: preserve-3d;
        transition: 0.6s;
        transform-style: preserve-3d;
      }
      /* front pane, placed above back */
      .front {
        -webkit-transform: rotateY(0deg);
        -ms-transform: rotateY(0deg);
        transform: ratateY(0deg);
        background: $white;
        z-index: 2;
      }

      /* back, initially hidden pane */
      .back {
        transform: rotateY(180deg);
        background: #f8f9fa;
        border-bottom: 1px solid $gray-lt;
        -webkit-transform: rotateY(-180deg);
        -moz-transform: rotateY(-180deg);
        -o-transform: rotateY(-180deg);
        -ms-transform: rotateY(-180deg);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Nav/MainNav.vue